import * as React from 'react'

import Tooltip from '../../tooltip'
import { IItemCard } from '../interface'

import {
  reportVideoFullscreen,
  reportVideoProgress
} from '../../../../common/analytics/videoHiveAnalytics'
import { getItemAttribute } from '../../../../common/utils/item'

import TrendingSash from '../../../components/trendingSash'
import SaleSash from '../../../components/saleSash'
import LockupAddToCartButton from '../lockupAddToCartButton'
import LockupPrice from '../lockupPrice'
import LockupRating from '../lockupRating'
import LockupSales from '../lockupSales'
import LockupTitleAuthor from '../lockupTitleAuthor'
import LockupVideoPreview from '../lockupVideoPreview'
import FeatureContainer from '../../../containers/feature'

import * as styles from './videoHiveItemCard.module.css'

interface IProps extends IItemCard {
  muted: boolean
  muteVideo: () => any
  unmuteVideo: () => any
  index: number
}

class VideoHiveItemCard extends React.Component<IProps> {
  public render() {
    const { item, muted, muteVideo, unmuteVideo } = this.props

    // sale sash overrides trending sash
    let sash = null
    if (item.trending) sash = <TrendingSash lazy />

    // For author driven price experiment
    if (item.original_price_cents)
      sash = (
        <FeatureContainer name="showWasNowPricing">
          <SaleSash lazy />
        </FeatureContainer>
      )

    return (
      <div className={styles.root} data-test-selector="video-hive-item-card">
        <article className={styles.card}>
          <section className={styles.preview}>
            {sash}
            <LockupVideoPreview
              {...this.props}
              reportVideoProgress={reportVideoProgress}
              reportVideoFullscreen={reportVideoFullscreen}
              muteVideo={muteVideo}
              unmuteVideo={unmuteVideo}
              muted={muted}
            />
          </section>

          <section className={styles.content}>
            <div className={styles.authorContainer}>
              <span className={styles.author}>
                <LockupTitleAuthor {...this.props} />
              </span>

              {this.renderClipsOrDuration()}
            </div>

            <div className={styles.cardDetail}>
              <div>
                <LockupPrice
                  originalPriceInCents={item.original_price_cents}
                  priceInCents={item.price_cents}
                />

                <span className={styles.cardMeta}>
                  <LockupRating {...this.props} />
                  <LockupSales {...this.props} />
                </span>
              </div>

              <div className={styles.cartButton}>
                <LockupAddToCartButton icon {...this.props} />
              </div>
            </div>
          </section>
        </article>
      </div>
    )
  }

  private renderClipsOrDuration() {
    const item = this.props.item
    const videoLength = getItemAttribute(item, 'length-video')
    const clips =
      getItemAttribute(item, 'after-effects-project-file-length') ||
      getItemAttribute(item, 'length-video-individual')
    const clipCount = typeof clips === 'string' ? clips.split(',').length : 0

    if (clipCount > 1 && clipCount <= 3) {
      return (
        <Tooltip title={clips} position={Tooltip.Position.TOP}>
          <span className={styles.clips}>{clipCount} Clips</span>
        </Tooltip>
      )
    }

    if (clipCount > 3) {
      return (
        <Tooltip
          title={`${clipCount} clips inside`}
          position={Tooltip.Position.TOP}
        >
          <span className={styles.clips}>{clipCount} Clips</span>
        </Tooltip>
      )
    }

    if (videoLength) {
      return <span className={styles.clips}>{videoLength}</span>
    }

    return null
  }
}

export default VideoHiveItemCard
